exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1oXAT {\n    padding: 0 20px;\n}\n\n.infoContainer_1oXAT > h3 {\n    text-align: center;\n    font-weight: 800;\n    padding-bottom: 10px;\n}\n\n.arbitrationAgreement_18nbK {\n    display: inline-block;\n    padding: 0 5px;\n}\n\n.arbitrationContainer_28jLt span {\n    font-size: 16px;\n}\n\n.sectionAgreement_3CGtJ {\n    padding: 15px 0;\n}\n\n.gapSection5_1bx0B {\n    height: 210px;\n}\n\n.initialBoxImage_2iERH img {\n    max-width: 100px;\n    max-height: 34px;\n    height: auto;\n    width: auto;    \n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1oXAT",
	"arbitrationAgreement": "arbitrationAgreement_18nbK",
	"arbitrationContainer": "arbitrationContainer_28jLt",
	"sectionAgreement": "sectionAgreement_3CGtJ",
	"gapSection5": "gapSection5_1bx0B",
	"initialBoxImage": "initialBoxImage_2iERH"
};